<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>
        <div>
          <label class="label-input">Score</label>
          <ckeditor :editor="editor" v-model="fields['trust-badge-score']" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <label class="label-input">Brand</label>
          <ckeditor :editor="editor" v-model="fields['brand-content']" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <label class="label-input">Images</label>
          <v-row>
            <v-col cols="12" md="4">
              <UploadImage
                @callback="obj => handleUploadImage(obj, 1)"
                :image="{ imageSrc: fields['trust-image-1'] }"
                :height="`150`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload(1)"
              />
            </v-col>
            <v-col cols="12" md="4">
              <UploadImage
                @callback="obj => handleUploadImage(obj, 2)"
                :image="{ imageSrc: fields['trust-image-2'] }"
                :height="`150`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload(2)"
              />
            </v-col>
            <v-col cols="12" md="4">
              <UploadImage
                @callback="obj => handleUploadImage(obj, 3)"
                :image="{ imageSrc: fields['trust-image-3'] }"
                :height="`150`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload(3)"
              />
            </v-col>
          </v-row>
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <SectionPadding
              class="mb-6"
              :fields="fields.sectionPadding"
              :reset-padding="{ topDesktop: 4, bottomDesktop: 4, topMobile: 4, bottomMobile: 4 }"
            />
            <div class="mt-6">
              <div class="font-weight-medium mb-3">Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['background-color']"
                    name="background-color"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['container-background-color']"
                    name="container-background-color"
                    label="Container Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['border-color']"
                    name="border-color"
                    label="Border Color"
                    default-color="#e0e0e0"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['trust-badge-score-bg-color']"
                    name="trust-badge-score-bg-color"
                    label="Score Background"
                    default-color="f5f5f5"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields['trust-badge-score-color']"
                    name="trust-badge-score-color"
                    label="Score Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';
import SectionPadding from './common/section-padding.vue';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

export default {
  name: 'trust-badge-section-editor',
  components: {
    ColorPicker,
    SectionPadding,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'brand-content': '',
        'trust-badge-score': '',
        'trust-image-1': '',
        'trust-image-2': '',
        'trust-image-3': '',
        'background-color': '#ffffff',
        'container-background-color': '#ffffff',
        'trust-badge-score-bg-color': 'f5f5f5',
        'trust-badge-score-color': '#000000',
        'border-color': '#e0e0e0',
        sectionPadding: {
          topDesktop: 4,
          bottomDesktop: 4,
          topMobile: 4,
          bottomMobile: 4,
        },
      },
    };
  },
  created() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTrustBadge(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, index) {
      if (index === 1) {
        console.log(this.fields['trust-image-1']);
        this.fields['trust-image-1'] = obj.imageSrc;
      } else if (index === 2) {
        this.fields['trust-image-2'] = obj.imageSrc;
      } else if (index === 3) {
        this.fields['trust-image-3'] = obj.imageSrc;
      }
    },
    handleRemoveUpload(index) {
      if (index === 1) {
        this.fields['trust-image-1'] = '';
      } else if (index === 2) {
        this.fields['trust-image-2'] = '';
      } else if (index === 3) {
        this.fields['trust-image-3'] = '';
      }
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 100px;
}
.ck-editor__editable {
  min-height: 100px;
}
</style>
